import React, { useState } from "react";

const Switch = ({toggleSwitch,isOn}) => {
  // const [isOn, setIsOn] = useState(false);

  // const toggleSwitch = () => {
  //   setIsOn(!isOn);
  // };

  const styles = {
    switchContainer: {
      display: "flex",
      alignItems: "center",
      gap: "0.5vw",
      cursor: "pointer",
    },
    switchTrack: {
      width: "3vw",
      height: "1.5vw",
      borderRadius: "1vw",
      backgroundColor: isOn ? "#4caf50" : "gray",
      position: "relative",
      transition: "background-color 0.3s ease",
    },
    switchThumb: {
      width: "1.5vw",
      height: "1.5vw",
      borderRadius: "50%",
      backgroundColor: "white",
      position: "absolute",
      transform: isOn ? "translateX(1.5vw)" : "translateX(0vw)",
      transition: "transform 0.3s ease",
    },
  };

  return (
    <div style={styles.switchContainer} onClick={toggleSwitch}>
      <div style={styles.switchTrack}>
        <div style={styles.switchThumb} />
      </div>
      {/* <div style={styles.switchLabel}>Open to Collaborate</div> */}
    </div>
  );
};

export default Switch;
